import {
  Button,
  Grid,
  Paper,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@mui/material'
import { memo, useCallback, useEffect, useState } from 'react'
import { isEqual } from 'lodash'
import { metodoPrograma } from '../../../../../components/api'
import { GiReceiveMoney, GiPayMoney, GiTakeMyMoney } from 'react-icons/gi'
import PrimeTable from '../../../../../components/PrimeTable'

const Item = ({ icon, label, value, color }) => (
  <Paper
    style={{
      backgroundColor: color,
      padding: 20,
      textAlign: 'center',
      height: 80,
    }}
  >
    <Grid container spacing={1}>
      <Grid xs={4} style={{ textAlign: 'center', padding: 8 }}>
        {icon}
      </Grid>
      <Grid
        xs={8}
        style={{
          textAlign: 'right',
          padding: 8,
          color: 'white',
        }}
      >
        <Typography style={{ fontSize: 12 }}>{label}</Typography>
        <Typography
          style={{
            fontWeight: 600,
            textAlign: 'right',
            fontSize: '1.2em',
          }}
        >
          {value}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
)

const ModalFechamentoCaixa = ({ data, close }) => {
  const [lista, setLista] = useState([])
  const [entradas, setEntradas] = useState(0.0)
  const [saidas, setSaidas] = useState(0.0)
  const [resultado, setResultado] = useState(0.0)
  const [loading, setLoading] = useState(false)

  const getList = useCallback(() => {
    metodoPrograma('listaLancamentosCaixa', {
      idCaixa: data?.idCaixa,
      idRegistro: data?.idRegistro,
      idLocalAtendimento: data?.idLocalAtendimento,
    }).then((res) => {
      if (res.status) {
        if (res.valorEntrada) setEntradas(res.valorEntrada)
        if (res.valorSaida) setSaidas(res.valorSaida)
        if (res.totalGeral) setResultado(res.totalGeral)
        setLista(res.lista || [])
      }
    })
  }, [data])

  useEffect(() => {
    getList()
  }, [getList])

  const handleFechar = async () => {
    setLoading(true)
    const res = await metodoPrograma('fechamentoDeCaixa', {
      idCaixa: data?.idCaixa,
      idRegistro: data?.idRegistro,
      idLocalAtendimento: data?.idLocalAtendimento,
    })
    setLoading(false)
    if (res?.status) {
      close(true)
    }
  }

  const formatCurrency = (v) =>
    v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

  return (
    <Dialog open={true} onClose={() => close(false)} fullWidth maxWidth="md">
      <DialogTitle>Fechamento de Caixa</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Item
              label="Entradas"
              value={formatCurrency(entradas)}
              color="rgb(67 160 71 / 61%)"
              icon={<GiReceiveMoney style={{ fontSize: 40, color: 'white' }} />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              label="Saídas"
              value={formatCurrency(saidas)}
              color="rgb(211 47 47 / 61%)"
              icon={<GiPayMoney style={{ fontSize: 40, color: 'white' }} />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              label="Saldo"
              value={formatCurrency(resultado)}
              color="rgb(25 118 210 / 61%)"
              icon={<GiTakeMyMoney style={{ fontSize: 40, color: 'white' }} />}
            />
          </Grid>
          <Grid item xs={12}>
            <PrimeTable
              dadosTable={lista}
              disablePagination
              head={[
                'Data',
                'Descrição',
                'Usuário',
                'Forma Pagamento',
                'Tipo',
                'Valor',
              ]}
              line={(item) => [
                item[0],
                item[1],
                item[2][1],
                item[3][1],
                item[4][1],
                item[5],
              ]}
              collumnsDate={[0]}
              collumnsCurrency={[5]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => close(false)}
          color="secondary"
          variant="contained"
          style={{ margin: '5px' }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleFechar}
          disabled={loading}
          variant="contained"
          color="primary"
          style={{ margin: '5px' }}
        >
          Confirmar Fechamento
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ModalFechamentoCaixa, isEqual)
